import RP8_EXT_1 from "./RP8_EXT_1";

export default {
  RP8_EXT_1,
};
